export function getUserId(sub) {
    return sub.split('|')[1] // Return everything after '|'
}